import * as Ariakit from '@ariakit/react';

import type { IconName } from '../../types/icons';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import Button from '../Button';
import Icon from '../Icon';

import * as S from './Menu.styled';

interface MenuPopoverProps extends Omit<Ariakit.MenuProps<'div'>, 'render'> {}
export const MenuPopover = (props: MenuPopoverProps) => (
  <Ariakit.Menu render={<S.MenuContainer />} portal autoFocusOnHide={false} {...props} />
);

interface MenuButtonProps
  extends Omit<Ariakit.MenuButtonProps<'button'>, 'render'>,
    ComponentPropsWithoutRef<typeof Button> {}
export const MenuButton = (props: MenuButtonProps) => (
  <Ariakit.MenuButton render={<Button />} {...props} />
);

interface MenuItemProps extends Omit<Ariakit.MenuItemProps<'div'>, 'render'> {
  iconName: IconName;
  label: ReactNode;
  description: ReactNode;
  variant?: 'regular' | 'danger';
}
export const MenuItem = ({
  iconName,
  label,
  description,
  variant = 'regular',
  ...props
}: MenuItemProps) => (
  <Ariakit.MenuItem render={<S.ItemContainer />} {...props}>
    <S.ItemIconContainer variant={variant}>
      <Icon name={iconName} width={20} height={20} />
    </S.ItemIconContainer>
    <S.ItemDetails>
      <S.ItemLabel variant={variant}>{label}</S.ItemLabel>
      <S.ItemDescription>{description}</S.ItemDescription>
    </S.ItemDetails>
  </Ariakit.MenuItem>
);

interface MenuSeparatorProps extends Omit<Ariakit.MenuSeparatorProps, 'render'> {}
export const MenuSeparator = (props: MenuSeparatorProps) => (
  <Ariakit.MenuSeparator render={<S.MenuSeparatorStyles />} {...props} />
);

export const { MenuProvider } = Ariakit;
